/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_Deep_Emu_HikeInputs */

const en_loud_deep_emu_hike = /** @type {(inputs: Loud_Deep_Emu_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role(s)`)
};

const de_loud_deep_emu_hike = /** @type {(inputs: Loud_Deep_Emu_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle(n)`)
};

/**
* | output |
* | --- |
* | "Role(s)" |
*
* @param {Loud_Deep_Emu_HikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loud_deep_emu_hike = /** @type {((inputs?: Loud_Deep_Emu_HikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Deep_Emu_HikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loud_deep_emu_hike(inputs)
	return de_loud_deep_emu_hike(inputs)
});